import React, { useState } from 'react';
import { useUnitLinks } from 'core/contexts/unitLinks';
import { Box, Fade, Grid2 } from '@mui/material';
import { PaginationControlled } from '@utriper/core-ui';
import UnitCard from '../UnitCard';
import UnitLinkForm from 'components/UnitLinkForm';

const UnitCards = ({ experienceId }) => {
    const { loadingExpLink, expLinks, expLinkPage, totalExpLinks, MAX_PAGE, setExpLinkPage, updateExperienceLink, submittingExpLink } = useUnitLinks();
    const [openForm, setOpenForm] = useState(false);
    const [unitToEdit, setUnitToEdit] = useState(null);

    const handleOpenForm = (newValue = true, unitData = {}) => {
        setOpenForm(newValue);
        if (Number.isInteger(unitData?.id)) {
            setUnitToEdit({ ...unitData });
        }
    };

    const handlePage = (event, newPage) => {
        setExpLinkPage(newPage);
    };

    const handleUpdateExperienceLink = async (unitData) => {
        await updateExperienceLink(experienceId, unitData);
        handleOpenForm(false);
        setUnitToEdit(null);
    };

    return (
        <React.Fragment>
            <Fade in={!loadingExpLink} timeout={300}>
                <Box component="section" display="flex" flexDirection="column" mt="24px" gap="24px">
                    <Grid2 container size={12} spacing={2}>
                        {expLinks.map(({ id, ...rest }) => (
                            <UnitCard key={id} id={id} handleOpenForm={handleOpenForm} {...rest} />
                        ))}
                    </Grid2>
                    {totalExpLinks / MAX_PAGE > 1 && <PaginationControlled count={Math.ceil(totalExpLinks / MAX_PAGE)} page={expLinkPage} onChange={handlePage} totalItems={totalExpLinks} itemsPerPage={MAX_PAGE} />}
                </Box>
            </Fade>

            <UnitLinkForm
                unitLinkId={unitToEdit?.id}
                initialValues={unitToEdit}
                onSubmit={handleUpdateExperienceLink}
                submitting={submittingExpLink}
                open={openForm}
                onClose={() => {
                    handleOpenForm(false);
                    setUnitToEdit(null);
                }}
                unitsCreated={expLinks || []}
            />
        </React.Fragment>
    );
};

export default UnitCards;
